import { ImageLinksApi } from "../../../../../../../services/Api/Organization/types";

export interface ModalImageLinkItem {
	index: number;
	modalImageLinkItem?: ImageLinksApi;
}

export enum ImageLinksMode {
	ADD_NEW,
	ADD_TO_EXISTING_FIELDS,
}
